import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../../components/SectionHeading";
import { aboutIcons } from "./aboutIcons";
import { valuesContent } from "./aboutContent";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

const AboutValues = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="about-values-heading"
  >
    <div className="sectionlayout">
      <SectionHeading
        id="about-values-heading"
        title={valuesContent.title}
      />
      <motion.dl
        className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.09 } } }}
      >
        {valuesContent.values.map((value) => {
          const Icon = aboutIcons[value.icon];
          return (
            <motion.div
              key={value.title}
              variants={cardVariants}
              className="brand-card items-center p-6 text-center lg:p-8"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[var(--brand-primary)] text-white shadow-md">
                <Icon aria-hidden="true" className="h-6 w-6" />
              </span>
              <dt className="mt-5 text-lg font-bold text-gray-900">
                {value.title}
              </dt>
              <dd className="mt-3 text-sm md:text-base leading-relaxed text-gray-600">
                {value.description}
              </dd>
            </motion.div>
          );
        })}
      </motion.dl>
    </div>
  </section>
);

export default AboutValues;
